import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "heading-sections"
}
const _hoisted_2 = {
  key: 0,
  class: "heading-content heading-preamble"
}
const _hoisted_3 = {
  key: 1,
  class: "heading-actions"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "heading-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HtmlMapper = _resolveComponent("HtmlMapper")
  const _component_Button = _resolveComponent("Button")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Collapse = _resolveComponent("Collapse")

  return ($options.sections.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        ($options.preamble.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_HtmlMapper, {
                restricted: $props.restricted,
                nodes: $options.preamble
              }, null, 8 /* PROPS */, ["restricted", "nodes"])
            ]))
          : _createCommentVNode("v-if", true),
        ($options.sections.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Button, {
                class: "expand-all",
                flat: "",
                onClick: $options.toggleAll
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($options.all_expanded ? 'Collapse all' : 'Expand all'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]))
          : _createCommentVNode("v-if", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sections, (section) => {
          return (_openBlock(), _createElementBlock("section", {
            key: section.index,
            class: _normalizeClass(["heading-section", {open: $options.isExpanded(section.index)}])
          }, [
            _createElementVNode("div", {
              class: "heading-title",
              onClick: $event => ($options.toggleSection(section.index))
            }, [
              _createVNode(_component_Ellipsis, { class: "heading-text" }, {
                default: _withCtx(() => [
                  _createVNode(_component_HtmlMapper, {
                    restricted: $props.restricted,
                    nodes: section.heading.childNodes
                  }, null, 8 /* PROPS */, ["restricted", "nodes"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */),
              _createVNode(_component_Icon, {
                class: "heading-chevron",
                icon: "chevron-down",
                size: _ctx.$responsive.mobile ? '2rem' : '1.4rem',
                stroke: 'var(--gray-500)'
              }, null, 8 /* PROPS */, ["size"])
            ], 8 /* PROPS */, _hoisted_4),
            _createVNode(_component_Collapse, {
              open: $options.isExpanded(section.index),
              "keep-alive": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_HtmlMapper, {
                    restricted: $props.restricted,
                    nodes: section.content
                  }, null, 8 /* PROPS */, ["restricted", "nodes"])
                ])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["open"])
          ], 2 /* CLASS */))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    : (_openBlock(), _createBlock(_component_HtmlMapper, {
        key: 1,
        restricted: $props.restricted,
        nodes: $props.nodes
      }, null, 8 /* PROPS */, ["restricted", "nodes"]))
}